module.exports = __webpack_public_path__ + "img/sld_mfm_inv_16_t1_b1_dark.7b8063ea.svg";